"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAuthoredPercentOutOf100 = exports.formatDataPointAsMetricNumber = exports.formatRefreshedSince = void 0;
var Localize_1 = require("../../gen-src/Localize");
var metrics_engine_1 = require("@tableau/metrics-engine");
function formatRefreshedSince(date) {
    var fromDate = Localize_1.Formatters.formatLongBestFitRelativeTime(date);
    return Localize_1.Messages.refreshedSince({ fromDate: fromDate });
}
exports.formatRefreshedSince = formatRefreshedSince;
function formatDataPointAsMetricNumber(measureAccessor, value, formatString) {
    var measure = value && measureAccessor(value);
    return (0, metrics_engine_1.formatValueAsMetricNumber)(measure, formatString);
}
exports.formatDataPointAsMetricNumber = formatDataPointAsMetricNumber;
/**
 * To be used by ConstnatComparisonValueInput
 *
 * When the formatString is a percentage, then we need to multiply the comparison value
 * by 100 for display. This function formats the display string to avoid floating point
 * precision errors after multiplication.
 *
 * @param value the preformatted number (i.e. 0.5 if the comparison is 50%)
 * @returns the formatted number
 */
function formatAuthoredPercentOutOf100(value) {
    // if the value is an integer, we don't need to worry about any of this
    if (Number.isInteger(value)) {
        return (value * 100).toString();
    }
    // Plus one so that the formatter trying to add a "%" at the end doesn't truncate our number at all
    var maxCharacters = value.toString().length + 1;
    // We don't want the "+", only the "-" when applicable
    var formattedWithPostfix = value < 0
        ? (0, metrics_engine_1.formatValueAsRelativePercentage)(value, maxCharacters)
        : (0, metrics_engine_1.formatValueAsUnsignedPercentage)(value, maxCharacters);
    // Removing the "%" at the end
    return formattedWithPostfix.substring(0, formattedWithPostfix.length - 1);
}
exports.formatAuthoredPercentOutOf100 = formatAuthoredPercentOutOf100;
//# sourceMappingURL=formatting.js.map